import SendDocumentForm from '@/pages/requests/creationPages/SendDocumentTemplate.vue'
import RequestDocumentForm from '@/pages/requests/creationPages/RequestDocumentTemplate.vue'
import BusinessDocumentsDetailPage from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentDetailPage.vue'
import BusinessDocumentsNegotiationForm from '@/pages/requests/negotiationPages/BusinessDocumentNegotiation.vue'
import BusinessDocumentList from '@/pages/requests/detailPages/businessDocumentDetailPages/BusinessDocumentList.vue'
import OCRScanForm from '@/pages/requests/creationPages/OCRScanTemplate.vue'
import OCRListPage from '@/pages/requests/OCRListPage.vue'
import OCRScanDetailPage from '@/pages/requests/detailPages/OCRScanDetailPage.vue'

export default [
  {
    path: '/businessDocument/sendForm',
    alias: [],
    component: SendDocumentForm
  },
  {
    path: '/businessDocument/requestForm',
    alias: [],
    component: RequestDocumentForm
  },
  {
    path: '/businessDocument/details',
    alias: [],
    component: BusinessDocumentsDetailPage
  },
  {
    path: '/businessDocument/negotiate',
    alias: [],
    component: BusinessDocumentsNegotiationForm
  },
  {
    path: '/businessDocument/documentsList',
    alias: [],
    component: BusinessDocumentList
  },
  {
    path: '/businessDocument/OCRScan',
    alias: [],
    component: OCRScanForm
  },
  {
    path: '/businessDocument/OCRList',
    alias: [],
    component: OCRListPage
  },
  {
    path: '/businessDocument/list/ocr/detail/:id',
    alias: ['/businessDocument/list/ocr/detail/'],
    component: OCRScanDetailPage
  }
]



// WEBPACK FOOTER //
// ./src/routes/services/businessDocuments.js